export async function getMe() {
  const r = await fetch("/api/v1/sso/me", {
    method: "GET",
    credentials: "include",
  });

  if (!r.ok) return null;

  const contentType = r.headers.get("content-type") || "";
  if (!contentType.includes("application/json")) {
    const text = await r.text();
    console.error("Expected JSON from /api/v1/sso/me but got:", contentType, text.slice(0, 200));
    return null;
  }

  return r.json();
}

export async function logoutLocal() {
  await fetch("/api/v1/sso/logout", {
    method: "POST",
    credentials: "include",
  });

  window.dispatchEvent(new Event("auth-changed"));
  window.location.href = "/";
}

export async function logout() {
  window.location.assign("/api/v1/sso/logout/federated");
}
